import React from 'react';
import { useTemplates } from '../../context/TemplatesContext';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { templates } = useTemplates();
  const companyName = templates?.companyName || '仙人掌影業有限公司';

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="copyright">
          © {currentYear} {companyName}. 版權所有.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
